import { css } from 'react-emotion'

const styles = {
  circle: css({
    borderRadius: '50%',
    color: '#fff !important',
    // lineHeight: '31px',
    fontSize: '13px !important',
    textAlign: 'center',
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/AvatarStyles.js